import { createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, createTextVNode as _createTextVNode, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = { class: "dresscode" }
const _hoisted_2 = { class: "dresscode__content" }
const _hoisted_3 = { class: "dresscode__inner" }
const _hoisted_4 = { class: "dresscode__section" }
const _hoisted_5 = { class: "dresscode__palette" }
const _hoisted_6 = { class: "dresscode__section" }
const _hoisted_7 = { class: "dresscode__rules" }
const _hoisted_8 = { class: "dresscode__rule" }
const _hoisted_9 = { class: "dresscode__mini-palette" }
const _hoisted_10 = { class: "dresscode__rule" }
const _hoisted_11 = { class: "dresscode__mini-palette" }

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _cache[11] || (_cache[11] = _createElementVNode("section", { class: "dresscode__hero" }, [
      _createElementVNode("div", { class: "dresscode__hero-overlay" }),
      _createElementVNode("div", { class: "dresscode__hero-content" }, [
        _createElementVNode("h1", null, "Dress code")
      ])
    ], -1 /* CACHED */)),
    _createElementVNode("section", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createCommentVNode(" Cérémonie "),
        _createElementVNode("div", _hoisted_4, [
          _cache[0] || (_cache[0] = _createElementVNode("h2", null, "Dress code — Cérémonie", -1 /* CACHED */)),
          _cache[1] || (_cache[1] = _createElementVNode("p", { class: "dresscode__subtitle" }, " Samedi 13 juin ", -1 /* CACHED */)),
          _createElementVNode("div", _hoisted_5, [
            (_openBlock(), _createElementBlock(_Fragment, null, _renderList($setup.paletteCeremonie, (color, i) => {
              return _createElementVNode("div", {
                key: color.hex,
                class: _normalizeClass(["dresscode__swatch", `dresscode__swatch--v${(i % 3) + 1}`]),
                style: _normalizeStyle({ backgroundColor: color.hex })
              }, null, 6 /* CLASS, STYLE */)
            }), 64 /* STABLE_FRAGMENT */))
          ]),
          _cache[2] || (_cache[2] = _createStaticVNode("<p class=\"dresscode__hint\" data-v-2995e008> Ces couleurs sont données à titre indicatif pour les tons — pas d&#39;inquiétude si ce n&#39;est pas exactement celle-ci que vous portez ! </p><p class=\"dresscode__intro\" data-v-2995e008> Nous avons choisi une palette colorée et nous serions très touchés qu&#39;elle soit respectée le Jour J✨ </p><p class=\"dresscode__intro\" data-v-2995e008> Rien d&#39;obligatoire évidemment, mais si vous avez envie de jouer le jeu, nous pensons que les photos seront encore plus belles. </p><div class=\"dresscode__tips\" data-v-2995e008><p data-v-2995e008><strong data-v-2995e008>Pour les femmes</strong>, robes, ensembles ou accessoires dans les tons de la palette. </p><p data-v-2995e008><strong data-v-2995e008>Pour les hommes</strong>, nous savons qu&#39;il n&#39;est pas évident de respecter ces couleurs, porter un costume (par exemple bleu marine) sera parfait, avec un petit rappel de couleur de la palette sur la cravate, le nœud papillon, la boutonnière, la ceinture, le mouchoir… </p></div><p class=\"dresscode__note\" data-v-2995e008> Le blanc et ses nuances sont réservés à la mariée : le blanc cassé, le crème, le blanc lin, le blanc argile, le blanc ivoire, le blanc écru, etc. </p>", 5))
        ]),
        _cache[10] || (_cache[10] = _createElementVNode("div", { class: "dresscode__divider" }, null, -1 /* CACHED */)),
        _createCommentVNode(" Brunch "),
        _createElementVNode("div", _hoisted_6, [
          _cache[7] || (_cache[7] = _createElementVNode("h2", null, "Dress code — Brunch", -1 /* CACHED */)),
          _cache[8] || (_cache[8] = _createElementVNode("p", { class: "dresscode__subtitle" }, " Dimanche 14 juin ", -1 /* CACHED */)),
          _cache[9] || (_cache[9] = _createElementVNode("p", { class: "dresscode__text" }, " Le lendemain, on inverse les rôles ! ", -1 /* CACHED */)),
          _createElementVNode("div", _hoisted_7, [
            _createElementVNode("div", _hoisted_8, [
              _cache[3] || (_cache[3] = _createElementVNode("div", { class: "dresscode__rule-label" }, " Vous ", -1 /* CACHED */)),
              _cache[4] || (_cache[4] = _createElementVNode("p", null, "On vous imagine en blanc ou tons très clairs", -1 /* CACHED */)),
              _createElementVNode("div", _hoisted_9, [
                (_openBlock(), _createElementBlock(_Fragment, null, _renderList($setup.paletteBrunch, (color, i) => {
                  return _createElementVNode("div", {
                    key: color.hex,
                    class: _normalizeClass(["dresscode__mini-swatch", `dresscode__swatch--v${(i % 3) + 1}`]),
                    style: _normalizeStyle({ backgroundColor: color.hex })
                  }, null, 6 /* CLASS, STYLE */)
                }), 64 /* STABLE_FRAGMENT */))
              ])
            ]),
            _createElementVNode("div", _hoisted_10, [
              _cache[5] || (_cache[5] = _createElementVNode("div", { class: "dresscode__rule-label" }, " Nous ", -1 /* CACHED */)),
              _cache[6] || (_cache[6] = _createElementVNode("p", null, "On portera les couleurs de la palette", -1 /* CACHED */)),
              _createElementVNode("div", _hoisted_11, [
                (_openBlock(), _createElementBlock(_Fragment, null, _renderList($setup.paletteCeremonie, (color, i) => {
                  return _createElementVNode("div", {
                    key: color.hex,
                    class: _normalizeClass(["dresscode__mini-swatch", `dresscode__swatch--v${(i % 3) + 1}`]),
                    style: _normalizeStyle({ backgroundColor: color.hex })
                  }, null, 6 /* CLASS, STYLE */)
                }), 64 /* STABLE_FRAGMENT */))
              ])
            ])
          ])
        ])
      ])
    ])
  ]))
}